import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import React from "react";
import { useLoaderData } from "react-router";
import { formatLongDate } from "utilities";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { getMoneyFormatter } from "utilities/formatter";
import SubLabel from "components/Atoms/Sublabel";

const CreditTransactionListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.CreditTransactionListFrontModel>();
  const moneyFormatter = getMoneyFormatter();

  return <ListTemplate
    title={RESX.Credit.CreditTransactionHistory}
    filterSet="creditTransaction_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={instr => window.CoreApi.Credit.ListCreditTransaction({...instr, clientId: site.currentEnvironment.client.clientId})}
    getId={item => item.creditTransactionId}
    layout={{
      type: "table",
      columns: [{
        key: "date",
        header: RESX.DateTime.lblDate,
        render: item => formatLongDate(item.createdUtc)
      }, {
        key: "service",
        header: RESX.Service.resxService,
        render: item => <div>
          <div>{item.referenceType}</div>
          <div>{item.description}</div>
          <SubLabel>{item.actorName}</SubLabel>
        </div>
      }, {
        key: "credits",
        header: "Credits",
        render: item => `${moneyFormatter.format(item.amount.amount)} ${item.amount.currency.toUpperCase()}`
      }]
    }}
    filters={<KeywordFilter placeholder={RESX.GeneralLabels.Search} />}
    functions={{
      mapFilterValuesToInstruction,
      mapResponseToFilterValues
    }}
  />;
};

export default CreditTransactionListApp;
